import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import clsx from 'clsx';
import React from 'react';
import { CatalogueProduct } from '../../../api/products/catalogue';
export interface CataloguePageListContentItemCardInlineParametersProps
  extends StandardDivProps<CataloguePageListContentItemCardInlineParametersClassKey> {
  product: CatalogueProduct;
}

export type CataloguePageListContentItemCardInlineParametersClassKey = 'root' | 'param' | 'label';

const themeSettings = { name: 'CataloguePageListContentItemCardInlineParameters' };
const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles<CataloguePageListContentItemCardInlineParametersClassKey, {}>({
      root: {
        ...theme.typography.caption,
        color: theme.palette.text.secondary,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
      },
      param: {
        display: 'flex',
        // flexDirection: 'column',
      },
      label: {
        paddingRight: '1ch',
        color: theme.palette.text.hint,
      },
    }),
  themeSettings,
);

const CataloguePageListContentItemCardInlineParameters = React.forwardRef<
  HTMLDivElement,
  CataloguePageListContentItemCardInlineParametersProps
>(({ className, classes: pClasses, product }, ref) => {
  const classes = useStyles({ classes: pClasses });

  const productVolumeRecord = product.parameters?.find((p) => p.code === '/commonParameters/volume');
  const productVoluemDisplayValue = productVolumeRecord
    ? `${productVolumeRecord.value} ${`${productVolumeRecord.unit}` || ''}`
    : null;

  return (
    <div ref={ref} className={clsx(classes.root, className)}>
      {/* <div className={classes.param}>
        <span className={classes.label}>{t('common/code')}:</span>
        <span>{product.sku || ''}</span>
      </div> */}
      {productVoluemDisplayValue && (
        <div className={classes.param}>
          {/* <span className={classes.label}>{t('productPage/minOrderableQuantity')}:</span> */}
          <span>{productVoluemDisplayValue}</span>
        </div>
      )}
      {/* <div className={classes.param}>
        <span className={classes.label}>{t('common/unit')}:</span>
        <span>{product.unit}</span>
      </div> */}
    </div>
  );
});

CataloguePageListContentItemCardInlineParameters.displayName = 'CataloguePageListContentItemCardInlineParameters';

export default withThemeProps(themeSettings)(CataloguePageListContentItemCardInlineParameters);
